import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { BaseService } from '../../_helpers';
import { ActivityConfigEntity } from '../entity/activity-config.entity';
import { defaultsDeep } from 'lodash';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var ActivityService = /** @class */ (function (_super) {
    tslib_1.__extends(ActivityService, _super);
    function ActivityService(http) {
        var _this = _super.call(this, 'config/activities/idAndNames', ActivityConfigEntity) || this;
        _this.http = http;
        return _this;
    }
    ActivityService.prototype.findForDeviceTypeIds = function (ids, options) {
        options = defaultsDeep(tslib_1.__assign({}, options), {
            params: {
                deviceTypeIds: ids,
            }
        });
        return _super.prototype.find.call(this, options);
    };
    ActivityService.ngInjectableDef = i0.defineInjectable({ factory: function ActivityService_Factory() { return new ActivityService(i0.inject(i1.HttpClient)); }, token: ActivityService, providedIn: "root" });
    return ActivityService;
}(BaseService));
export { ActivityService };
